var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalcony(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H22.5C22.7761 13 23 12.7761 23 12.5C23 12.2239 22.7761 12 22.5 12H9.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C9.44772 20 9 20.4477 9 21C9 21.5523 9.44772 22 10 22H22C22.5523 22 23 21.5523 23 21C23 20.4477 22.5523 20 22 20H10Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5C11 14.2239 11.2239 14 11.5 14C11.7761 14 12 14.2239 12 14.5V18.5C12 18.7761 11.7761 19 11.5 19C11.2239 19 11 18.7761 11 18.5V14.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14C14.2239 14 14 14.2239 14 14.5V18.5C14 18.7761 14.2239 19 14.5 19C14.7761 19 15 18.7761 15 18.5V14.5C15 14.2239 14.7761 14 14.5 14Z",
    fill: "#00112B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.5C17 14.2239 17.2239 14 17.5 14C17.7761 14 18 14.2239 18 14.5V18.5C18 18.7761 17.7761 19 17.5 19C17.2239 19 17 18.7761 17 18.5V14.5Z",
    fill: "#00112B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14C20.2239 14 20 14.2239 20 14.5V18.5C20 18.7761 20.2239 19 20.5 19C20.7761 19 21 18.7761 21 18.5V14.5C21 14.2239 20.7761 14 20.5 14Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcony);
export default __webpack_public_path__ + "static/media/balcony.34b25f24c59553c4bfdb26c419fcd2ce.svg";
export { ForwardRef as ReactComponent };